module.exports = __webpack_public_path__ + "static/media/apartment17.9377f1dc.jpg";